<template>
  <div class="pl-0 mb-2" v-if="selectedLocation != null">
    <v-menu v-if="selectedLocation != null" transition="slide-y-transition" bottom offset-y>
      <template v-slot:activator="{ on }" color="white">
        <v-btn
          v-on="on"
          color="white"
          style="padding-left:0px; margin-left:0px;padding-right:25px;"
          depressed
          :loading="!storeData || storeData.length < 1"
        >
          <v-icon style="margin-top:-8px" size="22" color="#484848">mdi-map-marker</v-icon>
          <div class="d-inline" style="text-align:left;color:#999;letter-spacing:normal">
            <span class="fs-12 text-capitalize" style="font-weight:400;color:#999">
              {{ selectedLocation.storeName }}
              <v-icon
                style="display: inline-block;position: absolute; padding-left: 4px; margin-top: -8px;font-size:28px;color:#a2a2a2"
              >mdi-chevron-down</v-icon>
            </span>
            <p class="fs-10 mb-0 warm-grey" style="text-align: left;font-size:12px;">
              <span style="text-transform:capitalize;font-weight:400;color:#999">Device ID:</span>
              <strong
                style="color: #333;letter-spacing:normal;font-weight:500;font-size:11px"
              >{{ selectedLocation.nasid }}</strong>
            </p>
          </div>
        </v-btn>
      </template>
      <v-list
        color="#fffaf5"
        max-height="200px"
        style="overflow-y:scroll; overflow-x: hidden;padding: 0px !important"
      >
        <v-list-item
          dense
          v-for="(location, index) in storeData"
          @click="selectLocation(location)"
          v-bind:key="location.nasid"
          v-bind:style="{
            'border-top': (index == 0) ? '0px' : 'solid 1px #ccc'
          }"
        >
          <v-list-item-content style="padding:0px 0px 0px 0px;">
            <v-list-item-title style="min-height: 20px;">
              <span
                class="fs-12 location-item"
                style="font-weight:400;text-transform:capitalize;"
              >{{ location.storeName }}</span>
              <img
                src="~/img/icons/green-tick.svg"
                style="height:20px;float:right;margin-left:10px;padding: 0px 5px;margin-top: -2px;"
                v-if="selectedLocation.nasid == location.nasid"
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-if="selectedLocation == null || storeData == null">Loading Locations</div>
  </div>
</template>

<script>
export default {
  name: "LocationSelector",
  props: ["storeData", "selectedLocation"],
  data: function() {
    return {};
  },
  methods: {
    selectLocation: function(location) {
      this.$emit("select-location", location);
    }
  }
};
</script>
